const img = require('./verified_merit_m_default.png'); export default img;